import markConversationsAsPhishingFromTable from './markConversationsAsPhishingFromTable';
import markItemsAsPhishingFromTable from './markItemsAsPhishingFromTable';
import { TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

export default function markRowsAsPhishingFromTable(
    rowKeys: string[],
    tableView: TableView,
    actionSource: ActionSource
) {
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            markConversationsAsPhishingFromTable(rowKeys, tableView, actionSource);
            break;

        case ReactListViewType.Message:
            markItemsAsPhishingFromTable(rowKeys, tableView, actionSource);
            break;
    }
}
